<!-- Left side - Menu Button -->
<div class="left-corner-control black">
    <a class="menu" *ngIf="!isMenuOpened; else menu" (click)="$event.stopPropagation(); toggleMenu(true)">
        <app-custom-icon [iconPath]="'assets/icons/general-icons.svg'" [imageName]="'icon-menu'">
        </app-custom-icon>
    </a>
    <ng-template #menu>
        <a class="close" (click)="toggleMenu(false)">
            <div class="menu-icon">
                <app-custom-icon [iconPath]="'assets/icons/general-icons.svg'" [imageName]="'icon-close'">
                </app-custom-icon>
            </div>
        </a>
    </ng-template>
    @if (isAsap && !isOnboardingCompleted(onboardingStatus$ | async)) {
    <div class="quick-start-mobile flex align-items-center justify-content-between px-3 py-3 cursor-pointer border-round-3xl ml-2"
         *featureFlag="'asapOnboarding'"
        #quickStartMobileButton
        (click)="openQuickStart($event)">
        <div class="flex flex-column align-items-start gap-2" >
            <span class="text-white font-bold text-sm">Quick Start</span>
        </div>
        <i class="pi pi pi-window-maximize text-white ml-2" ></i>
    </div>
    }
</div>

<app-quick-start-guide #qsMobile [onboardingData]="onboardingStatus$ | async"
    [asapFormId]="asapFormId$ | async"></app-quick-start-guide>

<app-mobile-full-menu *ngIf="isMenuOpened" (menuItemClickled)="toggleMenu(false)">
</app-mobile-full-menu>
